/** Compact INR for chart axes / tooltips (invalid → em dash, not a fake zero) */
export function formatCompactInr(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  if (abs >= 10000000) return `${sign}₹${(abs / 10000000).toFixed(2)}Cr`;
  if (abs >= 1000000) return `${sign}₹${(abs / 1000000).toFixed(2)}M`;
  if (abs >= 100000) return `${sign}₹${(abs / 100000).toFixed(2)}L`;
  if (abs >= 1000) return `${sign}₹${(abs / 1000).toFixed(2)}K`;
  return `${sign}₹${abs.toLocaleString("en-IN")}`;
}

/** Donut center: stable % display (avoids 100.009999…) */
export function formatDonutPercentTotal(total) {
  const n = Number(total);
  if (!Number.isFinite(n)) return "—";
  const roundedInt = Math.round(n);
  if (Math.abs(n - roundedInt) < 0.06) return `${roundedInt}%`;
  const rounded2 = Math.round(n * 100) / 100;
  const text =
    Number.isInteger(rounded2) ? String(rounded2) : rounded2.toFixed(2).replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
  return `${text}%`;
}

export function formatOptionalPercent(v, fractionDigits = 2) {
  if (v === undefined || v === null || v === "") return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return `${n.toFixed(fractionDigits)}%`;
}